import {createEntityMeta,SyncStatus} from '../offline/entity.js';
import {createSmokerCapabilities} from './smoker-capabilities.js';

export const SMOKER_CAPABILITY_ENTITY_TYPE='smoker_capability';

function requireDependencies(repository,queue,smokerStore){
  if(!repository?.get||!repository?.list||!repository?.put)throw new TypeError('repository with get/list/put is required');
  if(!queue?.enqueue||!queue?.markConflict)throw new TypeError('sync queue contract is required');
  if(!smokerStore?.get)throw new TypeError('smokerStore.get is required');
}

function withMeta(existing,domain,userId){
  const value={...(existing||{})};
  delete value.key;
  delete value.entityType;
  return {
    ...(existing?value:createEntityMeta({id:domain.smokerId,syncStatus:SyncStatus.PENDING_CREATE})),
    ...domain,
    id:domain.smokerId,
    userId
  };
}

export function createSmokerCapabilityStore({
  repository,
  queue,
  smokerStore,
  now=()=>new Date().toISOString()
}={}){
  requireDependencies(repository,queue,smokerStore);

  async function get(smokerId){
    return repository.get(SMOKER_CAPABILITY_ENTITY_TYPE,String(smokerId||'').trim());
  }

  async function save(smokerId,input={}){
    const smoker=await smokerStore.get(smokerId);
    if(!smoker)throw new TypeError('Smoker not found');
    const existing=await get(smokerId);
    if(existing?.syncStatus===SyncStatus.CONFLICT)throw new Error('SMOKER_CAPABILITY_CONFLICT');

    const domain=createSmokerCapabilities({...input,smokerId:smoker.id});
    const entity=withMeta(existing,domain,smoker.userId);
    if(!existing){
      entity.createdAt=now();
      entity.updatedAt=entity.createdAt;
    }
    return queue.enqueue(
      SMOKER_CAPABILITY_ENTITY_TYPE,
      entity,
      existing?'update':'create'
    );
  }

  async function list({userId=null}={}){
    const rows=await repository.list(SMOKER_CAPABILITY_ENTITY_TYPE);
    return Object.freeze((rows||[])
      .filter(row=>!userId||row.userId===userId)
      .sort((a,b)=>String(a.smokerId||a.id).localeCompare(String(b.smokerId||b.id))));
  }

  async function markConflict(smokerId,conflict){
    const current=await get(smokerId);
    if(!current)throw new TypeError('Smoker capability not found');
    return queue.markConflict(SMOKER_CAPABILITY_ENTITY_TYPE,current,conflict);
  }

  return Object.freeze({get,save,list,markConflict});
}
